import { doc, setDoc, getDoc, updateDoc } from "firebase/firestore";
import { db } from "../lib/firebaseConfig";
import { useAuth } from './auth'; // Import the useAuth hook

export const useToggleAIState = () => {
  const { user } = useAuth(); // Get the current user from useAuth hook

  const toggleAIState = async () => {
    try {
      if (!user) {
        console.error("User not authenticated.");
        return;
      }

      const aiSettingsRef = doc(db, "AISettings",  user.uid);
      const aiSettingsSnapshot = await getDoc(aiSettingsRef);

      if (aiSettingsSnapshot.exists()) {
        const currentAIState = aiSettingsSnapshot.data().isActive;
        const newAIState = !currentAIState; // Invert the state here

        await updateDoc(aiSettingsRef, { isActive: newAIState });
      } else {
        // If the document does not exist, set it to true initially
        await setDoc(aiSettingsRef, { isActive: true });
      }
    } catch (error) {
      console.error("Error toggling AI state:", error);
    }
  };

  return { toggleAIState };
};
